import { render, staticRenderFns } from "./statistical-analysis-skeleton-activity-dossier-base.vue?vue&type=template&id=145d0051&scoped=true&"
import script from "./statistical-analysis-skeleton-activity-dossier-base.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-activity-dossier-base.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-activity-dossier-base.scss?vue&type=style&index=0&id=145d0051&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "145d0051",
  null
  
)

export default component.exports